export default context => {
  return {
    namespaced: true,
    state: {},
    mutations: {},
  };
};
